import React from "react";
import OurWorks from "../components/ourwork/OurWorks";

const OurWorkPage = () => {
  return (
    <>
     <OurWorks/>
    </>
  );
};

export default OurWorkPage;
